export const COL_OPTIONS = { align: "left" }
